import { find, findAllBy } from "./base";

const EVENT_LOCATIONS = ["event_locations", "event_locations"];

export const eventLocation = (state) => (id) =>
  find(state)(EVENT_LOCATIONS, id);

export const eventLocations = (state) => (params) =>
  findAllBy(state)(EVENT_LOCATIONS, params);
